import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/firmen/$companyId/stammdaten")({
  component: StammdatenLayoutRoute,
});

function StammdatenLayoutRoute() {
  return <Outlet />;
}
